import {
  currentOrPastMonthYearDateUI,
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateDateRange } from 'platform/shared/health-apps';
import DateRangeDescription from '../../../../components/FormDescriptions/DateRangeDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--gulf-war-service-title'];
const DESC_TEXT = content['service-info--gulf-war-service-description'];
const INPUT_LABELS = {
  start: content['service-info--service-start-date-label'],
  end: content['service-info--service-end-date-label'],
};

const DEFAULT_OPTS = {
  hint: content['service-info--service-date-hint'],
  errorMessages: {
    pattern: content['validation-error--month-year-date-format'],
  },
};

const VALIDATIONS = [
  validateDateRange({
    startDateKey: 'gulfWarStartDate',
    endDateKey: 'gulfWarEndDate',
    monthYear: true,
    rangeErrorMessage: content['validation-error--service-date-range'],
  }),
];

const { gulfWarStartDate, gulfWarEndDate } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(DateRangeDescription),
    'view:gulfWarServiceDates': {
      gulfWarStartDate: currentOrPastMonthYearDateUI({
        title: INPUT_LABELS.start,
        ...DEFAULT_OPTS,
      }),
      gulfWarEndDate: currentOrPastMonthYearDateUI({
        title: INPUT_LABELS.end,
        ...DEFAULT_OPTS,
      }),
      'ui:validations': VALIDATIONS,
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:gulfWarServiceDates': {
        type: 'object',
        properties: {
          gulfWarStartDate,
          gulfWarEndDate,
        },
      },
    },
  },
};
